
/**
 * @param language
 * @returns the correct language attribute for a change language tag, based on the passed language
 */
export const getChangeLanguageLinkLang = (language: string) => language === 'en' ? 'es' : 'en'
